import { WorkPage } from "@components/pages/WorkPage"
import { SiteShell } from "@components/SiteShell"
import { workPageQueryOptions } from "@data/publicPageDataQuery"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"

export const Route = createFileRoute("/$locale/work")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(workPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "work", path: `/${locale}/work` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  const data = Route.useLoaderData()
  const labels = pageLabels(locale, "work")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <WorkPage
        data={data}
        locale={locale}
      />
    </SiteShell>
  )
}
